import React, { useState, useEffect } from "react";
import { isYandex } from "react-device-detect";
import ModuleMobile from "../ModuleMobile";
import CProtal from "../../UI/CPortal";
import "./style.scss";

const OFFSET_TOP = 100;
const minHeight = 315;
const calculateMaxHeightBottomSheet = () => window.innerHeight - 10;
const calculateMinHeightBottomSheet = () => {
    const playerBlock = document.getElementById('player-block');
    const streamTabsElement = document.getElementById('stream-tabs');
    let height;

    if (playerBlock) {
        height = window.innerHeight - playerBlock.offsetHeight - 10;
    }

    if (streamTabsElement) {
        height = (height ?? window.innerHeight) - streamTabsElement.offsetHeight - 10;
    }

    return height ?? minHeight;
}

const BottomSheet = ({
    moduleRef,
    modules,
    currentModule,
    setCurrentModule,
    handleOpenQuestionWriteForm,
    isFullscreen = false,
    settings,
    isNotPadding,
    modalIsOpen,
}) => {
    const className = 'spring-bottom-sheet';
    const [maxHeightBottomSheet, setMaxHeightBottomSheet] = useState(calculateMaxHeightBottomSheet());
    const [minHeightBottomSheet, setMinHeightBottomSheet] = useState(calculateMinHeightBottomSheet());
    const [isOpen, setIsOpen] = useState(isFullscreen);

    useEffect(() => {
        const resizeListener = () => {
            const maxHeightBottomSheet = calculateMaxHeightBottomSheet();
            let minHeightBottomSheet = calculateMinHeightBottomSheet();
            minHeightBottomSheet = minHeightBottomSheet < minHeight ? minHeight : minHeightBottomSheet;
            setMaxHeightBottomSheet(maxHeightBottomSheet);
            setMinHeightBottomSheet(minHeightBottomSheet);
        };

        window.addEventListener('resize', resizeListener);
        setTimeout(resizeListener, 100);

        const playerBlock = document.getElementById('player-block');
        const headerElement = document.getElementById('page-header');
        const menuElement = document.getElementById('page-mobile-menu');
        const streamTabsElement = document.getElementById('stream-tabs');

        if (headerElement) {
            headerElement.style.top = `${-headerElement.offsetHeight}px`;
        }

        if (menuElement) {
            menuElement.style.bottom = `${-menuElement.offsetHeight}px`;
        }

        const paddingHorizontal = isNotPadding ? '0px' : '10px';

        if (streamTabsElement) {
            streamTabsElement.style.position = 'fixed';
            streamTabsElement.style.top = !isFullscreen ? '5px' : `${-OFFSET_TOP}px`;
            streamTabsElement.style.left = 0;
            streamTabsElement.style.right = 0;
        }

        if (playerBlock && !isFullscreen) {
            playerBlock.style.position = 'fixed';
            playerBlock.style.top = streamTabsElement ? (streamTabsElement.offsetHeight + 10) + 'px' : '5px';
            playerBlock.style.left = paddingHorizontal;
            playerBlock.style.right = paddingHorizontal;
        }

        window.scrollTo({
            top: 0,
        });

        const disablePageScroll = (e) => {
            e.preventDefault();
        };

        document.body.style.overflow = 'hidden';
        document.addEventListener('scroll', disablePageScroll, { passive: false });

        return () => {
            if (streamTabsElement) {
                streamTabsElement.style.position = 'static';
                streamTabsElement.style.top = "";
                streamTabsElement.style.left = "";
                streamTabsElement.style.right = "";
            }

            if (playerBlock) {
                playerBlock.style.position = 'static';
                playerBlock.style.top = "";
                playerBlock.style.left = "";
                playerBlock.style.right = "";
            }

            if (headerElement) {
                headerElement.style.top = "";
            }

            if (menuElement) {
                menuElement.style.bottom = "";
            }

            window.removeEventListener('resize', resizeListener);
            document.body.style.overflow = 'auto';
            document.removeEventListener('scroll', disablePageScroll);
        }
    }, []);

    const onOpen = (_isOpen) => {
        const playerBlock = document.getElementById('player-block');
        const streamTabsElement = document.getElementById('stream-tabs');

        if (isOpen === _isOpen) {
            return;
        }

        if (streamTabsElement) {
            let top = parseInt(streamTabsElement.style.top || 0, 10);

            if (_isOpen) {
                top = top - streamTabsElement.offsetHeight - OFFSET_TOP;
            } else {
                top = top + streamTabsElement.offsetHeight + OFFSET_TOP;
            }
            streamTabsElement.style.top = `${top}px`;
        }

        if (playerBlock) {
            let top = parseInt(playerBlock.style.top || 0, 10);

            if (_isOpen) {
                top = top - playerBlock.offsetHeight - OFFSET_TOP;
            } else {
                top = top + playerBlock.offsetHeight + OFFSET_TOP;
            }
            playerBlock.style.top = `${top}px`;
        }

        setIsOpen(status => !status);
    };

    const keyboardShowHandler = () => {
        if (!isYandex) {
            return;
        }

        onOpen(true);
    }

    const height = isOpen ? maxHeightBottomSheet : minHeightBottomSheet;

    return (
        <CProtal>
            <div style={{height, zIndex: modalIsOpen ? 0 : 1}} className={`${className} ${isNotPadding ? '-notPadding' : ''}`}>
                <ModuleMobile
                    isFullscreen={isFullscreen}
                    moduleRef={moduleRef}
                    modules={modules}
                    currentModule={currentModule}
                    settings={settings}
                    setCurrentModule={setCurrentModule}
                    handleOpenQuestionWriteForm={handleOpenQuestionWriteForm}
                    onOpen={onOpen}
                    isOpen={isOpen}
                    keyboardShowHandler={keyboardShowHandler}
                />
            </div>
        </CProtal>
    );
}

export default BottomSheet;
